<script setup lang="ts">
import { ENTITIES } from '~/data/maquette'

/** Une entité dans le menu : icône, libellé et nombre de lignes de l'école courante. */
const props = defineProps<{ entityKey: string }>()
const view = useCurrentView()
const entity = computed(() => ENTITIES[props.entityKey]!)
const active = computed(() => (view.value.type === 'entity' || view.value.type === 'detail') && view.value.key === props.entityKey)
</script>

<template>
  <div
    :class="['nav-item', { active }]"
    @click="goTo('entity', entityKey)"
  >
    <AppIcon
      :name="entity.icon"
      extra="icon-sm"
    /><span class="nav-item-label">{{ entity.labelPlural }}</span><span class="count">{{ entityRows(entityKey).length }}</span>
  </div>
</template>
